export const MOBILE_HEADER_MAX_HEIGHT = 60;
export const DESKTOP_HEADER_MAX_HEIGHT = 124;

export const LOGO_MOBILE_SIZE = {
  height: 36,
  width: 65,
  margin: 'auto',
  resizeMode: 'contain',
};

export const LOGO_TABLET_SIZE = {
  ...LOGO_MOBILE_SIZE,
};

export const LOGO_DESKTOP_SIZE = {
  height: 60,
  width: 112,
  margin: 'auto',
  resizeMode: 'contain',
};

export const LOGO_WIDE_SIZE = {
  ...LOGO_DESKTOP_SIZE,
  margin: 'auto',
  resizeMode: 'contain',
};

export const LOGO_SIZES = {
  mobile: LOGO_MOBILE_SIZE,
  tablet: LOGO_TABLET_SIZE,
  desktop: LOGO_DESKTOP_SIZE,
  wide: LOGO_WIDE_SIZE,
};
